import { SET_COUNTS } from '../actions/types';

export default function counts(state = {}, action) {
	if (!action.error && action.payload !== undefined) {
		switch (action.type) {
			case SET_COUNTS:
				return action.payload;

			// no default
		}
	}

	return state;
}
